import { FeedbackDelay, ToneAudioNode } from "tone";
import { GrufBus } from "../GrufBus";
import { getAudioGraphInstance } from "../audioEngine";

export class DelayReturn extends ToneAudioNode {
    static parametersDescription = {
        ...GrufBus.parametersDescription,
        wet: { type: 'float', min: 0, max: 1, initial: 1 },
        time: { type: 'enum', options: ['1/4', '1/4T', '1/8', '1/8T', '1/16', '1/16T'], initial: '1/4' },
        feedback: { type: 'float', min: 0, max: 1, initial: 0.5 },
    }
    
    constructor() {
        super();
        this.delay = new FeedbackDelay();
        this.bus = new GrufBus();
        this.delay.connect(this.bus);
        this.input = this.delay;
        this.output = this.bus;
    }

    dispose() {
        this.delay.dispose();
        this.bus.dispose();
    }

    set gain(value) {
        this.bus.gain = value;
    }

    set wet(value) {
        this.delay.wet.value = value;
    }

    set feedback(value) {
        this.delay.feedback.value = value;
    }

    set time(value) {
        this.delay.delayTime.value = this.getDelayTimeValue(value);
    }

    getDelayTimeValue(delayTime) {
        const fraction = delayTime.replace("T", "");
        const isTriplet = delayTime.endsWith("T");
        let multiplier = {
            '1/4': 1,
            '1/8': 2,
            '1/16': 4,
        }[fraction];
        if (isTriplet) multiplier *= 1.5;
        return 60 / (multiplier*getAudioGraphInstance().getBpm());
    }

    getCurrentLevel() {
        return Math.max(...this.bus.getCurrentLevels());
    }

}